export const SET_MEDIAN = 'SET_MEDIAN';
export const SET_EST_PRICE_VALUE = 'SET_EST_PRICE_VALUE';
export const SET_RENTAL = 'SET_RENTAL';

export const FETCH_SNAPSHOT_LISTINGS = 'FETCH_SNAPSHOT_LISTINGS'
export const FETCH_EVALUATION_ADDRESS = 'FETCH_EVALUATION_ADDRESS'

